// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { Link } from '@tanstack/react-router';

// material ui
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import AlarmTypeCardHeader from './AlarmTypeCardHeader';

const FastSensorDown = ({ alarm }: { alarm: ReadAlarmDto }) => {
  const { t } = useTranslation('common');

  const sensorId = alarm?.Associations?.['Sensors']?.[0] || 'Unknown Sensor';

  return (
    <Card>
      <AlarmTypeCardHeader alarm={alarm} title={alarm.Title} />
      <Divider />
      <CardContent>
        <Typography variant="body1">{alarm.Message}</Typography>
      </CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          component={Link}
          to={'/$accountId/sensors/' + sensorId}
          size="small"
          color="primary"
        >
          {t('actions.goToItem', { item: 'Sensor' })}
        </Button>
      </CardActions>
    </Card>
  );
};

export default FastSensorDown;
